import IOfferProductsGet from 'api/interfaces/offers/IOfferProductsGet';
import getContributionMarginTotal from 'services/products/calculations/getContributionMarginTotal';
import getExpenseTotal from 'services/products/calculations/getExpenseTotal';
import getSellingPriceTotal from 'services/products/calculations/getSellingPriceTotal';

import getOfferQuantities from './getOfferQuantities';
import getPositionHours, {
  isAverageHourlyEarningsMissing,
} from './getPositionHours';

// The sums of a work type or of the whole offer, from the primary alternatives
export interface IWorkTypeFigures {
  contributionMargin: number;
  expense: number;
  hours: number;
  // Positions whose installation work has no average hourly earnings (no hours)
  missingAverageHourlyEarnings: number;
  // Quantities by unit, batch positions by their batch calculation review
  quantities: { [unit: string]: number };
  sellingPrice: number;
}

const getWorkTypeFigures = (
  positions: IOfferProductsGet[],
  installationCategories: any[]
): IWorkTypeFigures =>
  positions.reduce(
    (figures: IWorkTypeFigures, product) => {
      const primaryVersion = product.versions.find(
        (version) => version.isPrimary
      );

      if (primaryVersion === undefined) {
        return figures;
      }

      const { averageHourlyEarnings, installations, subproducts } =
        primaryVersion;

      return {
        ...figures,
        contributionMargin:
          figures.contributionMargin +
          getContributionMarginTotal(
            installations,
            subproducts,
            product.quantity
          ),
        expense:
          figures.expense +
          getExpenseTotal(installations, subproducts, product.quantity),
        hours:
          figures.hours +
          getPositionHours(
            installations,
            averageHourlyEarnings,
            product.quantity,
            installationCategories
          ),
        missingAverageHourlyEarnings:
          figures.missingAverageHourlyEarnings +
          (isAverageHourlyEarningsMissing(
            installations,
            averageHourlyEarnings,
            installationCategories
          )
            ? 1
            : 0),
        sellingPrice:
          figures.sellingPrice +
          getSellingPriceTotal(installations, subproducts, product.quantity),
      };
    },
    {
      contributionMargin: 0,
      expense: 0,
      hours: 0,
      missingAverageHourlyEarnings: 0,
      quantities: getOfferQuantities(positions),
      sellingPrice: 0,
    }
  );

export default getWorkTypeFigures;
